<script lang="ts" setup>

interface Props {
  background: string;
  color: string;
  text: string | number;
  icon?: string;
}

defineProps<Props>();
</script>

<template>
  <IonBadge>
    <div class="flex ion-align-items-center ion-nowrap">
      <IonIcon
        v-if="icon"
        class="mr-1 fa-fw"
        :class="icon"
      />
      {{ text }}
    </div>
  </IonBadge>
</template>

<style scoped>
ion-badge{
  --padding-bottom: 0.3rem;
  --padding-end: 0.8rem;
  --padding-start: 0.8rem;
  --padding-top: 0.3rem;
  border-radius: 10rem;
  --background: v-bind(background);
  --color: v-bind(color);
  font-size: 0.75rem;
}

ion-icon {
  --color: v-bind(color);
  padding: 0.1rem;
}
</style>
